import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Save } from 'lucide-react';

const ContentTab = ({ content, setContent, saving, onSave }) => {
  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-white">Site İçeriği</h2>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
        </Button>
      </div>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label className="text-zinc-300">Site Başlığı</Label>
            <Input
              value={content.site_title || ''}
              onChange={(e) => setContent({ ...content, site_title: e.target.value })}
              className="bg-zinc-800 border-zinc-700 text-white"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-zinc-300">Site Alt Başlığı</Label>
            <Input
              value={content.site_subtitle || ''}
              onChange={(e) => setContent({ ...content, site_subtitle: e.target.value })}
              className="bg-zinc-800 border-zinc-700 text-white"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Ana Açıklama</Label>
          <Textarea
            value={content.hero_description || ''}
            onChange={(e) => setContent({ ...content, hero_description: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white min-h-24"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Aksiyon Butonu Metni</Label>
          <Input
            value={content.cta_button_text || ''}
            onChange={(e) => setContent({ ...content, cta_button_text: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Alt Bilgi Açıklaması</Label>
          <Textarea
            value={content.footer_description || ''}
            onChange={(e) => setContent({ ...content, footer_description: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white min-h-24"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Yasal Uyarı Metni (Disclaimer)</Label>
          <Textarea
            value={content.disclaimer || ''}
            onChange={(e) => setContent({ ...content, disclaimer: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white min-h-24"
            placeholder="İlan detay sayfasının altında görünecek yasal uyarı metni"
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-zinc-300">Hakkında Şablonu</Label>
            <button
              type="button"
              onClick={() => setContent({ ...content, about_template_enabled: !content.about_template_enabled })}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${content.about_template_enabled !== false ? 'bg-emerald-600' : 'bg-zinc-700'}`}
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${content.about_template_enabled !== false ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
          {content.about_template_enabled !== false && (
            <>
              <Textarea
                value={content.about_template || ''}
                onChange={(e) => setContent({ ...content, about_template: e.target.value })}
                className="bg-zinc-800 border-zinc-700 text-white min-h-24"
                placeholder="Kullanılabilir değişkenler: {{category}}, {{city}}, {{count}}"
              />
              <p className="text-zinc-500 text-xs">İlan detay sayfasında "Hakkında" bölümünde görünür. Değişkenler: {"{{category}}"} = kategori, {"{{city}}"} = şehir, {"{{count}}"} = proje sayısı</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentTab;
